import { z } from 'zod';
export const userRoleSchema = z.enum(['admin', 'interviewer', 'candidate']);
/** `invited` = account created by an admin but the password link has not been used yet. */
export const userStatusSchema = z.enum(['invited', 'active', 'locked']);
/**
 * What a single-use token entitles its bearer to do. Both purposes share the same token
 * machinery (256-bit random, sha-256 at rest, expiry + revocation + single-use claim);
 * only the TTL, the email, and the link path differ.
 */
export const invitationPurposeSchema = z.enum(['account_setup', 'password_reset']);
export const userIdSchema = z.uuid();
export const userSchema = z.object({
    id: userIdSchema,
    email: z.email(),
    fullName: z.string().min(1),
    role: userRoleSchema,
    status: userStatusSchema,
    createdAt: z.iso.datetime(),
});
//# sourceMappingURL=user.js.map